/**
 * @generated SignedSource<<8b0873b61b96f3c1dc398fcceee3a980>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkList_linkList$data = {
  readonly links: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"IconLink_iconLink">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "LinkList_linkList";
};
export type LinkList_linkList$key = {
  readonly " $data"?: LinkList_linkList$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkList_linkList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkList_linkList",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IconLink",
      "kind": "LinkedField",
      "name": "links",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IconLink_iconLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LinkList",
  "abstractKey": null
};

(node as any).hash = "837f15f69f4dd0bc78f3bb90ca64aa4a";

export default node;
